module.exports = __webpack_public_path__ + "img/clouds_2_night.a09c23b4.svg";